import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core'
import Loading from './Loading'
import classNames from 'classnames';
const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.main,
        //minHeight: window.innerHeight
        minHeight: '100vh',
    },
    content:{
        paddingLeft: theme.spacing(3),
        marginTop: theme.spacing(40),
        // overflow:'scroll',
        width: '90%',
        marginLeft: '5%',
        marginRight: '5%',
        [theme.breakpoints.up('xl')]: {
            width: '80%',
            marginLeft: '10%',
            marginRight: '10%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '96%',
            marginLeft: '2%',
            marginRight: '2%',
            paddingLeft: 0,
            marginTop: theme.spacing(30),
        },
    },
    primary:{
        backgroundColor: theme.palette.background.primary,
    },
    secondary:{
        backgroundColor: theme.palette.background.secondary,
    },
    fullWidth: {
        width: '100%'
    },
    bottomPadding: {
        marginBottom: theme.spacing(3),
    }
})
class Container extends Component {
    render() {
        const { classes, children, className,showLoading, ...rest } = this.props;
        return (
            <Grid container item xs={12} className={classes.root}>
                <Grid container item xs={12} className={classNames(classes.content, {...className})} {...rest}>
                    {children}
                </Grid>
                {showLoading && <Loading showLoading={showLoading} />}
            </Grid>
        );
    }
}

export default withStyles(styles)(Container);